import type { RootState } from 'model/Redux';
import { Selector } from 'reselect';
import IAssetProfileModal from 'model/IAssetProfileModal';

export const selectAssetModalState: Selector<RootState, IAssetProfileModal> = state =>state.assetModalView.data; 

